app.components.slideshow = {
    onReady: function () {
        if ($('.slideshow').length) {
            return true;
        }
    },
    addListener: async function () {
        try {
            const [Swiper, swiperModules] = await Promise.all([
                import(/* webpackChunkName: "swiper" */ 'swiper'),
                import(/* webpackChunkName: "swiperPagination" */ 'swiper/modules'),
                import(/* webpackChunkName: "swiper" */ 'swiper/css')
            ]);
            const SwiperLib = Swiper.default;
            $('.slideshow').each(function () {

                let swiper = {
                    container: $(".swiper-container", this)[0],
                    params: {
                        speed: 1200,
                        spaceBetween: 40,
                        loop: false,
                        slidesPerView: 'auto',
                        watchOverflow: true,
                        modules: [swiperModules.Navigation],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    }
                };

                if (typeof window.swiperwAccessibilityParameters !== 'undefined') {
                    swiper.params.a11y = window.swiperwAccessibilityParameters;
                }

                new SwiperLib($(".swiper-container", this)[0], swiper.params);

            });
        } catch (error) {
            console.error('Error loading modules:', error);
        }
    }
};
